<template>
  <div class="page">
    <div class="success_box">
      <img src="../../assets/ic_success.png" />
      <span>支付成功</span>
    </div>

  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  mounted() { },
  computed: {},
  created() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
.success_box {
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  >span {
    margin-top: 24px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
  }
}

.footer {
  background-color: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;

  .com_box {
    padding: 10px;

    span {
      margin: 0 10px;
      font-size: 12px;
      color: #333333;
      text-align: center;
    }
  }

  .info {
    font-size: 12px;
    text-align: center;
    color: rgba($color: #333333, $alpha: 0.5);
  }
}</style>
